import { Trans } from 'react-i18next';
import React, { useMemo, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Accordion from 'react-bootstrap/Accordion';
import { Col } from 'react-bootstrap';
import MainBlockLayout from '../../components/MainBlockLayout';

import GDPR_policy_2022 from '../../files/GDPR_policy_2022.pdf';
import safeguarding_children from '../../files/safeguarding_children_child_protection_policy.pdf';
import Whistleblowing_Policy from '../../files/Whistleblowing_Policy.pdf';
import First_Aid_Policy from '../../files/First_Aid_Policy.pdf';
import E_Safety_policy from '../../files/E_Safety_policy.pdf';
import Anti_bullying_policy from '../../files/Anti_bullying_policy.pdf';
import Complaint_policies_new from '../../files/Complaint_policies_new.pdf';
import Health_and_Safety_Policy from '../../files/Health_and_Safety_Policy.pdf';
import equality_and_diversity_policy from '../../files/equality_and_diversity_policy.pdf';

import asthma_policy_2026 from '../../files/Asthma_Policy_2025-26.pdf';
import data_protection_parents_policy_2026 from '../../files/Data_protection_parents_2026.pdf';
import E_Safety_policy_2026 from '../../files/E_Safety_policy_2026.pdf';
import equality_and_diversity_policy_2026 from '../../files/equality_and_diversity_policy.pdf';
import First_Aid_policy_2026 from '../../files/First_Aid_Policy_2025-26.pdf';
import GDPR_policy_2026 from '../../files/GDPR_policy_2026.pdf';
import HR_policy_2026 from '../../files/HR_Policies_for_recruiting_St Marys_2026.pdf';
import safeguarding_children_policy_2026 from '../../files/safeguarding_children_child_protection_policy_2026.pdf';
import Specimen_Parent_Asthma_Letter_2026 from '../../files/Specimen_Parent_Asthma_Letter_2026.pdf';
import Staff_code_of_conduct_2026 from '../../files/Staff_code_of_conduct_2026.pdf';
import Whistleblowing_policy_2026 from '../../files/Whistleblowing_Policy.pdf';

function MainBlock() {
    const [activeDoc, setActiveDoc] = useState(null);

    const POLICY_GROUPS = useMemo(
        () => [
            {
                id: 'gdpr',
                titleKey: 'GDPR Policies',
                versions: [
                    {
                        year: 2022,
                        fileName: 'GDPR Policy',
                        previewLink: GDPR_policy_2022,
                        downloadLink:
                            'https://www.dropbox.com/s/eqk5n50yj8a8zsr/GDPR%20policy%202022.pdf?dl=1'
                    },
                    {
                        year: 2026,
                        fileName: 'GDPR policy',
                        previewLink: GDPR_policy_2026
                    }
                ]
            },
            {
                id: 'safeguarding',
                titleKey: 'Safeguarding Children - Child Protection Policies',
                versions: [
                    {
                        year: 2022,
                        fileName: 'Safeguarding Children Child Protection Policy',
                        previewLink: safeguarding_children,
                        downloadLink:
                            'https://www.dropbox.com/s/u9b0qxs2t7i2gbd/safeguarding_children_child_protection_policy.pdf?dl=1'
                    },
                    {
                        year: 2026,
                        fileName: 'Safeguarding Children Child Protection Policy',
                        previewLink: safeguarding_children_policy_2026
                    }
                ]
            },
            {
                id: 'whistleblowing',
                titleKey: 'Whistleblowing Policies',
                versions: [
                    {
                        year: 2022,
                        fileName: 'Whistleblowing Policy',
                        previewLink: Whistleblowing_Policy,
                        downloadLink:
                            'https://www.dropbox.com/s/kn2enhng6tazqs3/Whistleblowing%20Policy.pdf?dl=1'
                    },
                    {
                        year: 2026,
                        fileName: 'Whistleblowing Policy',
                        previewLink: Whistleblowing_policy_2026
                    }
                ]
            },
            {
                id: 'first-aid',
                titleKey: 'First Aid Policies',
                versions: [
                    {
                        year: '2022',
                        fileName: 'First Aid Policy',
                        previewLink: First_Aid_Policy,
                        downloadLink:
                            'https://www.dropbox.com/s/m0zubs7h3fvn2ur/First%20Aid%20Policy.pdf?dl=1'
                    },
                    {
                        year: '2025-2026',
                        fileName: 'First Aid Policy',
                        previewLink: First_Aid_policy_2026
                    }
                ]
            },
            {
                id: 'e-safety',
                titleKey: 'E-Safety Policies',
                versions: [
                    {
                        year: 2022,
                        fileName: 'E-Safety Policy',
                        previewLink: E_Safety_policy,
                        downloadLink:
                            'https://www.dropbox.com/s/llov5l6gwtvp2ek/E-Safety%20policy.pdf?dl=1'
                    },
                    {
                        year: 2026,
                        fileName: 'E-Safety Policy',
                        previewLink: E_Safety_policy_2026
                    }
                ]
            },
            {
                id: 'anti-bullying',
                titleKey: 'Anti-bullying Policies',
                versions: [
                    {
                        year: '2022-2026',
                        fileName: 'Anti-bullying Policy',
                        previewLink: Anti_bullying_policy,
                        downloadLink:
                            'https://www.dropbox.com/s/tpi3crsblwsk1ld/Anti-bullying%20policy.pdf?dl=1'
                    }
                ]
            },
            {
                id: 'complaints',
                titleKey: 'Complaint Policies',
                versions: [
                    {
                        year: '2022-2026',
                        fileName: 'Complaint Policy',
                        previewLink: Complaint_policies_new,
                        downloadLink:
                            'https://www.dropbox.com/s/o2bij9fy4hl0f02/Complaint%20policies%20%20new.pdf?dl=1'
                    }
                ]
            },
            {
                id: 'health-safety',
                titleKey: 'Health and Safety Policies',
                versions: [
                    {
                        year: '2022-2026',
                        fileName: 'Health and Safety Policy',
                        previewLink: Health_and_Safety_Policy,
                        downloadLink:
                            'https://www.dropbox.com/s/09ykuwbd8hzev5j/Health%20and%20Safety%20Policy%20September%202022%20St%20Marys.pdf?dl=1'
                    }
                ]
            },
            {
                id: 'equality-diversity',
                titleKey: 'Equality and Diversity Policies',
                versions: [
                    {
                        year: '2022-2025',
                        fileName: 'Equality and Diversity Policy',
                        previewLink: equality_and_diversity_policy,
                        downloadLink:
                            'https://www.dropbox.com/s/8qzdsgr1016bajy/equality-and-diversity%20policy.pdf?dl=1'
                    },
                    {
                        year: 2026,
                        fileName: 'Equality and Diversity Policy',
                        previewLink: equality_and_diversity_policy_2026
                    }
                ]
            },
            {
                id: 'asthma',
                titleKey: 'Asthma Policies',
                versions: [
                    {
                        year: 2026,
                        fileName: 'Asthma Policy',
                        previewLink: asthma_policy_2026
                    }
                ]
            },
            {
                id: 'data-protection-parents',
                titleKey: 'Data Protection for Parents Policies',
                versions: [
                    {
                        year: 2026,
                        fileName: 'Data Protection for Parents Policy',
                        previewLink: data_protection_parents_policy_2026
                    }
                ]

            },
            {
                id: 'hr',
                titleKey: 'HR Policies for Recruiting',
                versions: [
                    {
                        year: 2026,
                        fileName: 'HR Policy for Recruiting',
                        previewLink: HR_policy_2026
                    }
                ]

            },
            {
                id: 'specimen-parent-asthma-letter',
                titleKey: 'Specimen Parent Asthma Letter',
                versions: [
                    {
                        year: 2026,
                        fileName: 'Specimen Parent Asthma Letter',
                        previewLink: Specimen_Parent_Asthma_Letter_2026
                    }
                ]

            },
            {
                id: 'staff-code-of-conduct',
                titleKey: 'Staff Code of Conduct',
                versions: [
                    {
                        year: 2026,
                        fileName: 'Staff Code of Conduct',
                        previewLink: Staff_code_of_conduct_2026
                    }
                ]
            }
        ],
        []
    );

    return (
        <>
            <Container>
                <Row xs={1} sm={1} md={1}>
                    <Accordion alwaysOpen>
                        {POLICY_GROUPS.map((group, index) => (
                            <Accordion.Item eventKey={String(index)} key={group.id}>
                                <Accordion.Header>
                                    <Trans i18nKey={group.titleKey} />
                                </Accordion.Header>

                                <Accordion.Body>
                                    {group.versions
                                        .slice()
                                        .sort((a, b) => b.year - a.year)
                                        .map((doc) => (
                                            <Row key={group.id + '-' + doc.year} className="mb-3">
                                                <Col sm={12}>
                                                    {doc.fileName} ({doc.year})
                                                </Col>

                                                <Col sm={12} className="mt-2">
                                                    <Button
                                                        variant="success"
                                                        onClick={() =>
                                                            setActiveDoc({
                                                                ...doc,
                                                                titleKey: group.titleKey
                                                            })
                                                        }
                                                        style={{ marginRight: '15px' }}
                                                    >
                                                        <Trans i18nKey="Preview" />
                                                    </Button>

                                                    <a href={doc.downloadLink} download>
                                                        <Button variant="primary">
                                                            <Trans i18nKey="Download" />
                                                        </Button>
                                                    </a>
                                                </Col>
                                            </Row>
                                        ))}
                                    </Accordion.Body>
                                </Accordion.Item>
                        ))}
                    </Accordion>
                </Row>
            </Container>

            <Modal show={!!activeDoc} fullscreen onHide={() => setActiveDoc(null)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {activeDoc ? <Trans i18nKey={activeDoc.titleKey} /> : null}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {activeDoc ? (
                        <object
                            data={activeDoc.previewLink}
                            width="100%"
                            height="100%"
                            aria-label={activeDoc.fileName}
                        />
                    ) : null}
                </Modal.Body>
            </Modal>
        </>
    );
}

export default MainBlockLayout(MainBlock);
